
import Header from "@/components/header/header.vue";
import { reactive, inject, ref } from "vue";
import { useRouter } from "vue-router";
import { Dialog } from 'vant';
export default {
  components: {
    Header,
  },
  setup() {
    const $http: any = inject("$http");
    const router: any = useRouter();
    const $store:any = inject('$store')
    const logout = ref(false)
    const choiceList = reactive([
      {
        title: "Personal Info",
        url: "/update-profile",
      },
      {
        title: "Change Phone No.",
        url: "/modify-email?type=phone",
      },
      {
        title: "Change email No.",
        url: "/modify-email?type=email",
      },
      {
        title: "Modify Password",
        url: "/modifyPassword",
      },
       {
        title: "Frequent Asked Questions",
        url: "",
      },
    ]);
   if (common.getStorage('access_token')) {
      logout.value = true
    } else {
      logout.value = false

    }
    const clickLogoutFn = () => {
      Dialog.confirm({
            title: 'Tips',
            message: 'Are you sure you want to log out?',
            confirmButtonText:'Confirm',
            cancelButtonText:'Cancel'
            })
            .then(() => {
                // on confirm
               $http.clearToken();
              common.delStorage('username')
              common.delStorage("user_info");
              common.delStorage('ususer_infoer')
              common.delStorage('access_token');
              common.delStorage('kong_access_token');
              common.delStorage("refresh_token");
              router.push("/login");  
              common.delStorage('key')
              $store.setCart(null)         
            })
            .catch(() => {
              //取消
            });
      
    };
    const jumpClick = (item: any) => {
      if (item.url) {
        router.push(item.url);
      } else {
        window.location.href = "https://kilimall.freshdesk.com/support/solutions"
      }
      
    };

    return {
      choiceList,
      jumpClick,
      clickLogoutFn,
      logout,
    };
  },
};
